import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { API } from '@getgreenline/homi-shared'
import { TaxModels, taxApi } from '@getgreenline/products'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { Row, Col, Table, Empty, Tag, Spin, Divider, Popconfirm, Button, Icon, message } from 'antd'
import { EditTaxGroupModal } from './EditTaxGroupModal'
import { parseErrorMsg } from '../../../../utilities/helpers'
import Helmet from 'react-helmet'

interface Props {
  currentCompanyStore: CurrentCompanyStore
}

interface State {
  selectedTaxGroup?: TaxModels.TaxGroup
  showEditTaxGroupModal: boolean
  editTaxGroup?: TaxModels.TaxGroup
  taxes: TaxModels.ITaxContract[]
}

@inject('currentCompanyStore')
@observer
export class TaxSettings extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      showEditTaxGroupModal: false,
      taxes: [],
    }
  }

  componentDidMount = async () => {
    await this.getTaxes()

    this.props.currentCompanyStore!.productStore!.getTaxGroups()
  }

  async deleteTaxGroup(taxGroupId: number) {
    try {
      await this.props.currentCompanyStore!.productStore!.deleteTaxGroup(taxGroupId)
      message.success('Tax group successfully deleted')
    } catch (error) {
      message.error(parseErrorMsg(error) || 'There was an error removing this tax group')
    }
  }

  getTaxes = async () => {
    try {
      const taxes = await taxApi.getTaxes()

      this.setState({ taxes })
    } catch (error) {
      message.error(parseErrorMsg(error) || 'An error occurred while loading taxes')
    }
  }
  render() {
    const { taxGroups } = this.props.currentCompanyStore!.productStore!

    if (!taxGroups) {
      return <Spin />
    }

    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Taxes',
        dataIndex: 'taxLines',
        key: 'taxLines',
        align: 'right' as any,
        render: (taxLines: TaxModels.TaxLine[]) => {
          return (
            <span>
              {taxLines.map((taxLine) => {
                return (
                  <Tag color='blue' key={taxLine.id}>
                    {taxLine.percent}%
                  </Tag>
                )
              })}
            </span>
          )
        },
      },
      {
        title: 'Total percent',
        dataIndex: 'totalPercent',
        key: 'totalPercent',
        align: 'right' as any,
        render: (totalPercent: number) => {
          return `${totalPercent}%`
        },
      },
      {
        title: 'Actions',
        key: 'action',
        render: (text: string, taxGroup: TaxModels.TaxGroup) => {
          return (
            <span>
              <a
                onClick={() =>
                  this.setState({ showEditTaxGroupModal: true, editTaxGroup: taxGroup })
                }
              >
                Edit
              </a>
              <Divider type='vertical' />
              <Popconfirm title='Are you sure?' onConfirm={() => this.deleteTaxGroup(taxGroup.id)}>
                <a>Delete</a>
              </Popconfirm>
            </span>
          )
        },
      },
    ]

    return (
      <Row className='white-rounded-container'>
        <Helmet>
          <title>Settings | Taxes</title>
          <meta name='page-loaded' content='true' />
        </Helmet>

        <Row>
          <Col sm={24} lg={12}>
            {taxGroups.length === 0 ? (
              <Empty description='No taxes added' />
            ) : (
              <Table
                rowKey={(record) => String(record.id)}
                columns={columns}
                dataSource={taxGroups}
                pagination={false}
              />
            )}
            <br />
            <Button type='primary' onClick={() => this.setState({ showEditTaxGroupModal: true })}>
              <Icon type='plus' />
              Add tax group
            </Button>
          </Col>
        </Row>

        {this.state.showEditTaxGroupModal && (
          <EditTaxGroupModal
            taxes={this.state.taxes}
            taxGroup={this.state.editTaxGroup}
            onClose={() => this.setState({ showEditTaxGroupModal: false, editTaxGroup: undefined })}
            onSubmit={() => {
              this.setState({ showEditTaxGroupModal: false, editTaxGroup: undefined })
              this.props.currentCompanyStore!.productStore!.getTaxGroups()
            }}
          />
        )}
      </Row>
    )
  }
}
